var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-drawer" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "container",
      },
      [
        _c(
          "div",
          {
            staticClass: "detail-item",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c("div", { staticClass: "info" }, [
              _c("h5", [_vm._v(_vm._s(_vm.detail.title))]),
              _c("span", [
                _c("label", [_vm._v("SPU：")]),
                _vm._v(" " + _vm._s(_vm.detail.id) + " "),
              ]),
              _c("span", [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("stores::products-info::goods_cate")) + "："
                  ),
                ]),
                _vm._v(" " + _vm._s(_vm.detail.categoryNames) + " "),
              ]),
              _c("span", [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("stores::products-info::supplier")) + "："
                  ),
                ]),
                _vm._v(" " + _vm._s(_vm.detail.supplier) + " "),
              ]),
              _c("span", [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("stores::products-info::currency")) + "："
                  ),
                ]),
                _vm._v(" " + _vm._s(_vm.detail.spuCurrency) + " "),
              ]),
            ]),
            _c("img", {
              staticStyle: { width: "120px", height: "120px" },
              attrs: { src: _vm.detail.spuImages && _vm.detail.spuImages[0] },
            }),
          ]
        ),
        _c("div", { staticClass: "detail-item" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("stores::products-info::photos"))),
          ]),
          _c(
            "div",
            { staticClass: "images-list" },
            _vm._l(_vm.detail.spuImages, function (item, index) {
              return _c(
                "el-popover",
                {
                  key: index,
                  staticClass: "images",
                  attrs: { placement: "top-start", trigger: "hover" },
                },
                [
                  _c("img", {
                    staticStyle: { width: "150px", height: "150px" },
                    attrs: { src: item },
                  }),
                  _c("img", {
                    staticStyle: { width: "150px", height: "150px" },
                    attrs: { slot: "reference", src: item },
                    slot: "reference",
                  }),
                ]
              )
            }),
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "detail-item" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("stores::products-info::goods_sku"))),
            ]),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              _vm._l(_vm.detail.skus, function (item, index) {
                return _c("el-col", { key: index, staticClass: "sku" }, [
                  _c("div", { staticClass: "sku-item" }, [
                    _c("img", {
                      staticStyle: { width: "120px", height: "120px" },
                      attrs: { src: item.imageUrl },
                    }),
                    _c(
                      "div",
                      { staticClass: "sku-content" },
                      [
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("SKU"),
                          ]),
                          _c("span", [_vm._v(_vm._s(item.id))]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("stores::products-info::purchase_price")
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(item.purchasePrice)) +
                                "(￥)"
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "stores::products-info::compare_at_price"
                                )
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(item.compareAtPrice)) +
                                "($)"
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("stores::products-info::sale_price")
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(item.salePrice) + "($)")
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("stores::products-info::goods_stock")
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$dataCheck(item.skuInventory))),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("stores::products-info::safe_stock")
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$dataCheck(item.safeInventory))),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("stores::products-info::weight"))
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(item.weight)) +
                                _vm._s(item.weightUnit)
                            ),
                          ]),
                        ]),
                        _vm._l(item.options, function (option, oIndex) {
                          return _c("div", { key: oIndex }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v(_vm._s(option.name)),
                            ]),
                            _c("span", [_vm._v(_vm._s(option.value || "--"))]),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ])
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "detail-item" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("stores::products-info::goods_chart"))),
            ]),
            _c("rich-editor", {
              attrs: {
                placeholder: _vm.$t("stores::products-info::input_goods_chart"),
              },
              model: {
                value: _vm.spuSizeDesc,
                callback: function ($$v) {
                  _vm.spuSizeDesc = $$v
                },
                expression: "spuSizeDesc",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "detail-item" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("stores::products-info::goods_detail"))),
            ]),
            _c("rich-editor", {
              attrs: {
                placeholder: _vm.$t(
                  "stores::products-info::input_goods_detail"
                ),
              },
              model: {
                value: _vm.spuLongDesc,
                callback: function ($$v) {
                  _vm.spuLongDesc = $$v
                },
                expression: "spuLongDesc",
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }